import { t } from '../i18n/runtime';
/**
 * Bottom tab bar — used by G1 Home, P1 Calendar, P5 Leaderboard, P2 Profile.
 *
 * Pure DOM; no framework. Pass current tab id + a navigate callback.
 */
import { type IconName, iconString } from './icons';

const TABS: Array<{ id: string; route: string; icon: IconName; labelKey: string }> = [
  { id: 'home', route: '/', icon: 'home', labelKey: 'nav.home' },
  { id: 'calendar', route: '/calendar', icon: 'calendar', labelKey: 'nav.calendar' },
  { id: 'leaderboard', route: '/leaderboard', icon: 'trophy', labelKey: 'nav.leaderboard' },
  { id: 'profile', route: '/profile', icon: 'profile', labelKey: 'nav.profile' },
];

export function tabbar(activeId: string, onNavigate: (route: string) => void): HTMLElement {
  const nav = document.createElement('nav');
  nav.className = 'tabbar';
  nav.setAttribute('aria-label', 'Primary');
  nav.innerHTML = TABS.map(
    (tab) => `
    <button class="tab ${tab.id === activeId ? 'is-active' : ''}" data-route="${tab.route}" ${tab.id === activeId ? 'aria-current="page"' : ''}>
      <span class="tab-icon" aria-hidden="true">${iconString(tab.icon, 22)}</span>
      <span class="tab-label">${t(tab.labelKey)}</span>
    </button>
  `,
  ).join('');
  nav.addEventListener('click', (ev) => {
    const btn = (ev.target as HTMLElement | null)?.closest('.tab') as HTMLElement | null;
    if (!btn) return;
    const route = btn.getAttribute('data-route');
    if (route) onNavigate(route);
  });
  return nav;
}

export const TAB_IDS = TABS.map((t) => t.id);
